export class Utils {
  /**
   * Allows async timeout instead of the old callback style timeout.
   * SEE: https://stackoverflow.com/a/33292942/413785
   */
  static wait(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  static getArrayBuffer(data: string) {
    const buf = new ArrayBuffer(data.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== data.length; ++i) {
      // tslint:disable-next-line:no-bitwise
      view[i] = data.charCodeAt(i) & 0xff;
    }
    return buf;
  }
}